import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../../../../modules/src/lib/core/services/menu.service';
import { OrganizationManager } from '../../../managers/organization.manager';

@Component({
  selector: 'app-organization-header',
  templateUrl: './organization-header.component.html',
  styleUrls: ['./organization-header.component.scss'],
  standalone: false,
})
export class OrganizationHeaderComponent implements OnInit {

  public organizationName: string = 'Chargement en cours...';

  constructor(public menuService: MenuService, public organizationManager: OrganizationManager) {
  }

  ngOnInit(): void {
    this.organizationManager.getCurrent().then(organization => this.organizationName = organization.name);
  }
}
